/**
 * This enum lists every different type of error which can be the result of an API call; values should be given by
 * the proper error code associated with that type of error.
 */
export enum ApiErrorType {
  /**This usually is associated with attempts by the app to require access to server-side features which are NOT currently supported
   * by that particular server version.
   */
  OK = 200,
  NOT_FOUND = 404,
  INTERNAL_ERROR = 500,
  UNAUTHORISED = 401,
  NOT_ALLOWED = 405,
  CONTENT_TOO_LARGE = 413,
}
